import { Link } from "react-router-dom";
import type { Movie } from "@/types/content";

interface MovieCardProps {
  movie: Movie;
  showSynopsis?: boolean;
}

export default function MovieCard({ movie, showSynopsis = true }: MovieCardProps) {
  return (
    <Link to={`/movie/${movie.id}`} className="group block">
      <div className="relative aspect-[3/4] w-full overflow-hidden rounded-lg bg-secondary-100">
        <img
          src={movie.poster}
          alt={`${movie.title}（${movie.year}）电影海报`}
          title={`${movie.title} ${movie.year} 经典八十年代电影`}
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.05]"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/95 px-2.5 py-1 font-label text-[11px] tracking-widest text-primary-800">
          {movie.year}
        </span>
        <span className="absolute bottom-3 right-3 flex items-center gap-1 rounded-full bg-primary-950/75 px-2.5 py-1 text-[11px] text-accent-200 backdrop-blur-sm">
          <i className="ri-star-fill text-[10px] text-accent-400"></i>
          {movie.rating.toFixed(1)}
        </span>
        <div className="absolute inset-0 flex items-end bg-gradient-to-t from-primary-950/85 via-primary-950/10 to-transparent p-4 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex items-center gap-1.5 text-xs text-background-100">
            查看影片资料
            <i className="ri-arrow-right-line"></i>
          </span>
        </div>
      </div>
      <div className="mt-3">
        <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
          {movie.title}
        </h3>
        <p className="mt-1 font-label text-[11px] uppercase tracking-[0.14em] text-secondary-600">
          {movie.originalTitle}
        </p>
        <p className="mt-1.5 text-xs text-secondary-600">
          {movie.year} · {movie.genres.join(" / ")} · {movie.runtime} 分钟
        </p>
        {showSynopsis && (
          <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">
            {movie.synopsis}
          </p>
        )}
      </div>
    </Link>
  );
}